import { Injectable } from '@angular/core';
import { AssetsService } from './assets.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  public configState: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(public assetsService: AssetsService) {
    this.assetsService.getAssetAsJson("api/Config").then(
      (configState) => {
        this.configState.next(configState);
    },
    () => {
      this.configState.next(null);
    });
  }
}
